import React, { Component } from "react";
import PedidoDevolucaoMaterial from "../PedidoDevolucaoMaterial";

export default class PedidoMaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <PedidoDevolucaoMaterial tipoPedido={0} {...this.props} />;
  }
}
